export default "__VITE_ASSET__BKm2yye0__"